var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAccount = function SvgAccount(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 360",
    style: {
      enableBackground: "new 0 0 490 360"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M121.4,291.5C152.7,323.8,196.5,344,245,344c94.8,0,172-77.2,172-172S339.8,0,245,0S73,77.2,73,172 c0,45.2,17.6,86.4,46.2,117.1C119.8,290.1,120.6,290.8,121.4,291.5z M245,324.2c-37.4,0-71.8-13.6-98.3-36.1 c44.6-14.8,61.1-32.8,67.2-44.8c8.5,3.7,18,5.7,28.5,5.8c0.2,0,0.5,0,0.7,0c0.1,0,0.7,0,0.9,0s0.5,0,0.7,0 c11.4-0.2,21.7-2.5,30.6-6.8c5.7,12,21.9,30.6,67.8,45.8C316.7,310.6,282.4,324.2,245,324.2z M189.4,140.2c0-0.2,0-0.4,0-0.6 c2.4-52.1,40.8-56.2,52.6-56.2c0.5,0,0.9,0,1.2,0s0.5,0,0.8,0s0.6,0,1.2,0c11.7,0,50.2,4.1,52.6,56.2c0,0.2,0,0.4,0,0.6 c0.1,0.5,5,48.7-17.5,74c-8.9,10-20.8,15-36.3,15.1c-0.1,0-0.3,0-0.3,0l0,0c-0.1,0-0.2,0-0.3,0c-15.6-0.2-27.4-5.1-36.3-15.1 C184.5,189.1,189.3,140.7,189.4,140.2z M245,19.8c83.9,0,152.2,68.3,152.2,152.2c0,38.4-14.4,73.6-37.9,100.4 c-64.6-18.8-67.1-41.6-67.1-41.9c0,0.4,0,0.5,0,0.5h-0.7c1.2-1.2,2.4-2.4,3.6-3.7c27.5-30.9,22.9-83.8,22.4-89 c-2.7-55.2-40.6-74.8-72.3-74.8c-0.6,0-1.2,0-1.6,0c-0.4,0-0.9,0-1.6,0c-31.7,0-69.7,19.6-72.3,74.8c-0.5,5.1-5,58,22.4,89 c1.6,1.8,3.3,3.5,5,5.1c-2.1,5.8-12.7,24.2-66.4,39.9c-23.6-26.8-37.9-61.9-37.9-100.3C92.8,88.1,161.1,19.8,245,19.8z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccount, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account.c9e97c09.svg";
export { ForwardRef as ReactComponent };